import { Injectable } from '@angular/core';
import { SessionService } from '../Core/services/session.service';

@Injectable({
  providedIn: 'root',
})
export class AuthDataService {
  civilId: string = '';
  mobile!: string;
  passwrod!: string;
  confirmPassword!: string;
  isGregorian!:boolean;
  PasswordActive!:boolean;
  birthDate!:string;
  attemptCount: number = 0;
  alreadyChecked: boolean = false;


  reload() {
    this.civilId = '';
    this.mobile = '';
    this.passwrod = '';
    this.confirmPassword = '';
    this.isGregorian=false;
    this.birthDate='';
    this.PasswordActive=false;
    this.attemptCount = 0;
    this.alreadyChecked = false;
  }
}
